import React from "react";
import KYouthFeature from "../feature/KYouthFeature";
import KYouthSectionTitle from "../sectionTitle/KYouthSectionTitle";

const KYouthService = () => {
  return (
    <div
      id="what-we-offer"
      style={{
        scrollMarginBlockStart: 200,
      }}
      className="eduvibe-about-us-one-service edu-service-area edu-section-gapBottom bg-color-white service-bg-position"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row">
          <div className="col-lg-12">
            <KYouthSectionTitle
              classes="text-center"
              slogan="What We Offer"
              title="Learning New Skills While Earning"
            />
          </div>
        </div>

        <KYouthFeature />

        <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
          <div className="shape-image shape-image-1">
            <img
              src="/k-youth/images/shapes/shape-04-03.png"
              alt="Shape Thumb"
            />
          </div>
          <div className="shape-image shape-image-2">
            <img
              src="/k-youth/images/shapes/shape-02-07.png"
              alt="Shape Thumb"
            />
          </div>
          <div className="shape-image shape-image-3">
            <img src="/k-youth/images/shapes/shape-15.png" alt="Shape Thumb" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYouthService;
